import { getAccType } from '../services/accountingTypeService';
import { useQuery } from '@tanstack/react-query';

const useAccountingTypes = () => useQuery({
    queryKey: ['accountingTypes'],
    queryFn: () => getAccType().then(res => res.data),
    staleTime: 1000 * 60 * 60 * 24 * 365 // 1 year
});

export default useAccountingTypes;